package com.wintermar.inspection.core.ui.component.badge.variant

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember

@Composable
fun BadgeType.toModel(badgeSizeType: BadgeSizeType, strong: Boolean): BadgeVariantModel {
    val palette = toPaletteVariant().palette()
    val size = badgeSizeType.toSizeVariant().size()

    return remember(this, badgeSizeType, strong) {
        BadgeVariantModel(
            color = if (strong) palette.strong else palette.default,
            size = size
        )
    }
}

private fun BadgeType.toPaletteVariant(): BadgePaletteVariant = when (this) {
    BadgeType.GRAY -> BadgePaletteVariant.Gray
    BadgeType.BLUE -> BadgePaletteVariant.Blue
    BadgeType.YELLOW -> BadgePaletteVariant.Yellow
    BadgeType.GREEN -> BadgePaletteVariant.Green
    BadgeType.RED -> BadgePaletteVariant.Red
    BadgeType.GRAY_GREEN -> BadgePaletteVariant.GrayGreen
}

private fun BadgeSizeType.toSizeVariant(): BadgeSizeVariant = when (this) {
    BadgeSizeType.SMALL -> BadgeSizeVariant.Small
    BadgeSizeType.MEDIUM -> BadgeSizeVariant.Medium
    BadgeSizeType.LARGE -> BadgeSizeVariant.Large
}
